import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["menu", "icon"]

    toggle(event) {
        event.stopPropagation()
        this.menuTarget.classList.toggle("hidden")

        // Rotate the arrow icon when open
        if (this.hasIconTarget) {
            const isOpen = !this.menuTarget.classList.contains("hidden")
            this.iconTarget.style.transform = isOpen ? 'rotate(180deg)' : 'rotate(0deg)'
        }
    }

    close(event) {
        // Close the menu if clicking outside of the controller element
        if (!this.element.contains(event.target)) {
            this.menuTarget.classList.add("hidden")
            if (this.hasIconTarget) {
                this.iconTarget.style.transform = 'rotate(0deg)'
            }
        }
    }
}